import { Box, Grid, Tooltip, Typography } from '@mui/material';

import { CandidateDetails } from '../../candidateLayout/components/childComponets/CandidateDetailsCard/CandidateDetailsCard';

interface OtherSubmissionDetailsProps {
  details: CandidateDetails[];
}
const OtherSubmissionDetails: React.FC<OtherSubmissionDetailsProps> = ({ details }) => {
  return (
    <>
      {details.map((detail, index) => {
        const { title: label, value } = detail;

        return (
          <Grid item xs={3} key={index} mt={2} mb={2}>
            <Grid container direction="column" ml={4} rowGap={0.5}>
              <Grid item>
                <Tooltip title={label}>
                  <Typography
                    sx={{
                      fontSize: 12,
                      overflow: 'hidden',
                      display: 'block',
                      whiteSpace: 'nowrap',
                      textOverflow: 'ellipsis',
                    }}
                  >
                    {label}
                  </Typography>
                </Tooltip>
              </Grid>
              <Grid item>
                <Tooltip title={Array.isArray(value) ? value.join(', ') : String(value)}>
                  <Box
                    sx={{
                      fontSize: 14,
                      overflow: 'hidden',
                      whiteSpace: 'nowrap',
                      textOverflow: 'ellipsis',
                      width: 100,
                      cursor: 'pointer',
                    }}
                  >
                    {Array.isArray(value) ? value.join(', ') : value}
                  </Box>
                </Tooltip>
              </Grid>
            </Grid>
          </Grid>
        );
      })}
    </>
  );
};

export default OtherSubmissionDetails;
